module.exports = __webpack_public_path__ + "img/TDLogoForButton.5e76483a.svg";